const NOTIFICATION_KEY = 'testNotifications';

export const saveNotifications = (notifications) => {
    try {
        let existing = [];
        const storedData = localStorage.getItem(NOTIFICATION_KEY);

        if (storedData) {
            try {
                existing = JSON.parse(storedData) || [];
            } catch (parseError) {
                console.error('Error parsing stored notifications:', parseError);
                // Clear corrupted data
                localStorage.removeItem(NOTIFICATION_KEY);
            }
        }

        const notificationMap = new Map();
        existing.forEach(notif => notificationMap.set(notif.testId, notif)); // Create a map to handle duplicates

        // Add new notifications (overwrite duplicates)
        notifications.forEach(notif => notificationMap.set(notif.testId, notif));

        // Save updated list
        localStorage.setItem(NOTIFICATION_KEY, JSON.stringify([...notificationMap.values()]));
    } catch (error) {
        console.error('Error saving notifications to localStorage:', error);
    }
};

export const getNotifications = () => {
    try {
        const stored = localStorage.getItem(NOTIFICATION_KEY);
        if (!stored) return [];

        return JSON.parse(stored) || [];
    } catch (error) {
        console.error('Error retrieving notifications:', error);
        // Clear corrupted data
        localStorage.removeItem(NOTIFICATION_KEY);
        return [];
    }
};

export const clearNotifications = (testIds = []) => {
    try {
        const current = getNotifications();

        if (testIds.length === 0) {
            localStorage.removeItem(NOTIFICATION_KEY);
            return;
        }

        const filtered = current.filter(
            notif => !testIds.includes(notif.testId)
        );

        localStorage.setItem(NOTIFICATION_KEY, JSON.stringify(filtered));
    } catch (error) {
        console.error('Error clearing notifications:', error);
    }
};